<template>
    <div>
        <div class="level">
            <div class="level-item level-left">
                <app-filter v-model="appSelected" expanded @input="reloadData()" placeholder="Select App First" :preSelect="$store.state.guide_application_id">
                </app-filter>
            </div>
        </div>
        <div class="columns" v-if="appSelected!==null">
            <div class="column is-2">
                <b-select v-model="filter.topicId" placeholder="Select Topic"  @input="updateTopicId" expanded>
                    <option :value="null">Select Topic</option>
                        <option
                            v-for="option in topics"
                            :value="option.id"
                            :key="option.id">
                            {{ option.attributes.title }}
                        </option>
                </b-select>
            </div>
            <div class="column is-2">
                <b-select v-model="filter.testResultId" placeholder="Select Test Result" @input="reloadSteps()" expanded>
                    <option :value="null">Select Test Result</option>
                        <option
                            v-for="option in testResults"
                            :value="option.id"
                            :key="option.id">
                            {{ option.name }} {{ option.created_at | date }}
                        </option>
                </b-select>
            </div>
            <div class="column is-5">
                <div class="buttons">
                    <b-button type="is-danger" @click="deleteUnassigned()">
                        DELETE UNASSIGNED
                    </b-button>
                </div>
            </div>
            <div class="column is-3">
                <b-button type="is-info" v-if="sorting!==true" @click="modeChange">
                    Copy & Sort Mode
                </b-button>
                <b-button type="is-info" v-else @click="modeChange">
                    Regular Mode
                </b-button>
                <b-checkbox v-model="show" :native-value="true" type="is-dark" class="m-l-md line-height-2">
                    Show Hidden
                </b-checkbox>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="level">
                    <div class="level-item level-left">
                        <b-field>
                            <b-select v-model="topicSelected">
                                <option :value="null">Not assigned</option>
                                <option v-for="(item, index) in topics" :key="index" :value="item.id">
                                    {{item.attributes.title}}
                                </option>
                            </b-select>
                            <b-button type="is-default" @click="startUpdating()" :disabled="!stepsToUpdate.length">
                                Assign
                            </b-button>
                            <b-button :disabled="!stepsToUpdate.length" class="m-l-sm" @click="multipleRestoreOrArchive(true)">
                                Restore
                            </b-button>
                            <b-button :disabled="!stepsToUpdate.length" class="m-l-sm m-r-sm" @click="multipleRestoreOrArchive(false)">
                                Archive
                            </b-button>
                            <b-button :disabled="!stepsToUpdate.length" @click="multipleDelete">
                                Delete
                            </b-button>
                        </b-field>
                    </div>
                    <div class="level-item level-right">
                        <b-field>
                            <router-link :to="{name:'steps.create'}">
                                <b-button>
                                    Create Step
                                </b-button>
                            </router-link>
                        </b-field>
                    </div>
                </div>
            </div>
        </div>
        <b-loading :isFullPage="false" :active="true" v-if="!isLoaded">
            <h1>
                <b-icon icon="loading" custom-class="mdi-spin"/>
                <span v-if="isCloning">Cloning {{cloneIndex}} of {{stepsToClone.length}}</span>
                <span v-else-if="isUpdating">{{countMode}} {{updateIndex}} of {{stepsToUpdate.length}}</span>
                <span v-else>Loading {{page}} of {{total_pages}}</span>
            </h1>
        </b-loading>
        <div v-else-if="appSelected && isLoaded">
            <div v-if="sorting" class="columns box">
                <div class="column">
                    <center class="is-uppercase m-b-lg">Topic Steps</center>
                    <draggable :list="topic_steps" @change="sort($event,'topic')" group="steps" class="list-group">
                        <div v-for="step in topic_steps" :key="step.id" class="m-t-sm">
                            <div class="box" v-show="isShow(step) && (show || step.attributes.status)">
                                {{step.id}}. {{step.attributes.name}}
                            </div>
                        </div>
                    </draggable>
                </div>
                <div class="column">
                    <center class="is-uppercase m-b-lg">Test Steps</center>
                    <draggable :list="test_steps" @change="sort($event,'test')" :group="{ name: 'steps', pull: 'clone', put: false }" class="list-group">
                        <div v-for="step in test_steps" :key="step.id" class="m-t-sm">
                            <div class="box" v-show="isShow(step) && (show || step.attributes.status)">
                                {{step.id}}. {{step.attributes.name}}
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>
            <b-table :data="topic_steps" :columns="columns" v-else checkable :checked-rows.sync="stepsToUpdate">
                <template slot-scope="props" v-if="show ? true : props.row.attributes.status">
                    <b-table-column>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column class="ellipsis">
                        <span @click="edit(props.row)" v-if="props.row.id!==rowOnEdit">
                            {{props.row.attributes.name}}
                        </span>
                        <!-- <b-input v-show="props.row.id===rowOnEdit" v-model="props.row.attributes.name" @blur="save(props.row)" :ref="'name'+props.row.id"></b-input> -->
                        <!-- <b-input
                            icon-right="close-circle"
                            icon-right-clickable
                            @icon-right-click="e => cancelEdit(e)"
                            v-show="props.row.id===rowOnEdit"
                            v-model="rowOnEditName"
                            @blur="onRowOnEditBlur(props.row)"
                            @keyup.native.enter="onRowOnEditEnter(props.row)"
                            :ref="'name'+props.row.id"
                        ></b-input> -->
                        <b-field grouped v-show="props.row.id===rowOnEdit">
                            <b-input v-model="rowOnEditName" expanded @blur="onRowOnEditBlur(props.row)" @keyup.native.enter="onRowOnEditEnter(props.row)" :ref="'name'+props.row.id"></b-input>
                            <p class="control">
                                <b-button type="is-dark" icon-right="close" @mousedown="cancelEdit"></b-button>
                            </p>
                        </b-field>
                    </b-table-column>
                    <!-- <b-table-column>
                        <div class="columns">
                            <span class="column is-full">
                                {{props.row.attributes.test_result_name}}
                            </span>
                        </div>
                        <b-tooltip :label="props.row.attributes.test_result_name || 'N/A'">
                            <b-icon icon="clipboard-check"></b-icon>
                        </b-tooltip>
                    </b-table-column>
                    <b-table-column>
                        <span v-if="!props.row.attributes.test_result_id">
                            {{getTopicName(props.row.attributes.topic_id)}}
                        </span>
                        <b-tooltip :label="getTopicName(props.row.attributes.topic_id) || 'N/A'">
                            <b-icon icon="bookmark"></b-icon>
                        </b-tooltip>
                    </b-table-column> -->
                    <b-table-column class="min-width-15">
                        <div class="buttons">
                            <b-field>
                                <b-button type="is-primary" size="is-small" position="is-right" class="m-0" @click="goToEdit(props.row)" icon-left="pencil"/>
                                <b-checkbox-button
                                @input="save(props.row)"
                                size="is-small"
                                type="is-default"
                                >
                                    <b-icon :icon="props.row.attributes.status ? 'eye-off-outline' : 'eye-outline'" class="hide-button"/>
                                </b-checkbox-button>
                                <b-button type="is-danger" size="is-small" icon-left="trash-can" v-if="!props.row.attributes.test_result_id" @click="deleteStep(props.row)"/>
                            </b-field>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import _ from 'lodash';
import draggable from 'vuedraggable'
import AppFilter from '../../../../../components/AppFilter.vue'

export default {
    components:{
        draggable,
        AppFilter
    },
    name:"Step",
    data() {
        return {
            columns:[
                {
                    field:'id',
                    label:'Id'
                },
                {
                    field:'name',
                    label:'Name'
                },
                // {
                //     field:'Test Result',
                //     label:''
                // },
                // {
                //     field:'topic_id',
                //     label:''
                // },
                {
                    field:'actions',
                    label:'Actions'
                }
            ],
            testResults:[],
            rowOnEdit:null,
            rowOnEditName: "",
            toast:null,
            show: false,
            filter:{
                topicId:null,
                testResultId:null
            },
            page:1,
            sorting:false,
            steps:[],
            // Topic steps must not be a computed variable so draggable will work properly (sort)
            topic_steps: [],
            captions:[],
            images:[],
            isLoaded:false,
            topics:[],
            appSelected:null,
            apps:[],
            isFirstLoad: true,
            total_pages:null,
            stepsToClone:[],
            isCloning:false,
            cloneIndex:1,
            stepsToUpdate:[],
            topicSelected:null,
            isUpdating: false,
            updateIndex:1,
            countMode:null
        }
    },
    props:{
        topicId:{
            default:null
        }
    },
    watch:{
        testResultId(){
            this.filter.testResultId = this.testResultId
        },
        async show(){
            // this.topic_steps = []
            this.isLoaded = false
            await this.reloadSteps()
            this.isLoaded = true
        },
        "filter.topicId"(topicId) {
            this.$store.commit("SET_GUIDE_TOPIC", topicId);
        },
        "filter.testResultId"(testResultId) {
            this.$store.commit("SET_GUIDE_TEST_RESULT", testResultId);
        },
        steps() {
            this.topic_steps = _.filter(this.steps,(step)=>{
                return step.attributes.topic_id!==null && (!this.show ? step.attributes.status : true)
            })
        }
    },
    computed:{
        filteredSteps(){
            let steps = this.steps
            if(!this.sorting){
                if(this.filter.topicId){
                    let topicId = this.filter.topicId
                    steps = _.filter(steps,(step)=>{
                        return step.attributes.topic_id+''===topicId
                    });
                }
                if(this.filter.testResultId){
                    let testResultId = this.filter.testResultId
                    steps = _.filter(steps,(step)=>{
                        return step.attributes.test_result_id===testResultId
                    });
                }
            }
            return steps ? steps : []
        },
        test_steps(){
            return _.filter(this.steps,(step)=>{
                return step.attributes.test_result_id!==null
            })
        },
        // topic_steps(){
        //     return _.filter(this.steps,(step)=>{
        //         return step.attributes.topic_id!==null && (!this.show ? step.attributes.status : true)
        //         // return step.attributes.topic_id!==null
        //     })
        // }
    },
    async mounted(){
        this.isLoaded = false
        // this.filter.topicId = this.topicId
        // await this.getTestResults();
        // await this.getSteps();
        // await this.getTopics();
        // this.apps = this.$store.state.apps
        this.appSelected = this.$store.state.guide_application_id
        this.isLoaded = true;
    },
    methods: {
        async getSteps(){
            if(!Object.keys(this.$store.state.images).length){
                // let params = `?page=${this.page}&application_id=${this.appSelected}`
                // Leaving it up to the UI to split because we want both topics and tests
                // but place them in different UI parts. Using filters means we don't
                // get some desired results from API. E.g. if filtering by topic_id
                // then test result steps wouldn't even end up reaching the UI.
                /*
                if(this.filter.topicId){
                    params = params+`&topic_id=${this.filter.topicId}`
                }
                if(this.filter.testResultId){
                    params = params+`&test_result_id=${this.filter.testResultId}`
                }
                */

                // Removed application_id filter
                // Steps should gain their relationship with application from either the parent test_result or topic.
                let params = `?page=${this.page}&op=or&include_inactive=1`;
                if (this.filter.topicId){
                    params = params+`&topic_id=${this.filter.topicId}`
                }
                if (this.filter.testResultId){
                    params = params+`&test_result_id=${this.filter.testResultId}`
                }
                return Vue.$stepService.getAll(params).then(async (response)=>{
                    this.page++
                    let steps = this.steps
                    await response.data.forEach((row)=>{
                        steps.push(row);
                    })
                    this.steps = steps;
                    this.total_pages = response.meta.pagination.total_pages
                    if(response.meta.pagination.total_pages>=this.page) {
                        await this.getSteps()
                    }else{
                        this.$store.commit('SET_IMAGES',{
                            steps:this.steps
                        })
                        this.isLoaded = true
                    }
                })
            }else{
                this.steps = this.$store.state.images.steps
                return this.isLoaded = true
            }
        },
        getTopics() {
            let params = '?without_steps=true'
            if(this.appSelected){
                params = params+'&application_id='+this.appSelected
            }
            Vue.$topicService.topicList(params).then(async (response)=>{
                this.topics = response.data
            })
        },
        getTestResults(){
            let params = ''
            if(this.appSelected){
                params = '?application_id='+this.appSelected
            }
            Vue.$testResultService.getAsOptions(params).then((response)=>{
                this.testResults = response.data
            })
        },
        goToEdit(row) {
            this.$router.push({
                name:'steps.edit',
                params:{
                    id:row.id
                }
            })
        },
        async save(row, status = null) {
            this.cancelEdit();
            if(this.toast){
                this.toast.close()
            }
            await Vue.$stepService.update({
                name:row.attributes.name,
                topic_id:row.attributes.topic_id,
                status: status !== null ? status : !row.attributes.status
            },row.id).then((response)=>{
                var steps = this.$store.state.images.steps;
                let index = _.findIndex(this.$store.state.images.steps,{id:row.id});
                steps.splice(index,1,response.data);
                this.$store.commit('SET_IMAGES',{
                    images:this.$store.state.images.images,
                    steps:steps
                })

                let show = this.show

                this.toast = this.$buefy.toast.open({
                    message: 'Step saved!',
                    type: 'is-success',
                    queue: false
                })
            })
        },
        edit(row) {
            this.rowOnEdit = row.id
            this.rowOnEditName = row.attributes.name;
            this.$refs['name'+row.id].focus()
        },
        cancelEdit() {
            this.rowOnEditName = "";
            this.rowOnEdit = null;
        },
        onRowOnEditEnter(row) {
            row.attributes.name = this.rowOnEditName;
            this.save(row, row.attributes.status);
        },
        onRowOnEditBlur(row) {
            if (this.rowOnEdit) {
                this.onRowOnEditEnter(row);
            }
        },
        deleteUnassigned(){
            this.$buefy.dialog.confirm({
                title:'Are you sure?',
                message:'Are you sure you want to <strong>DELETE UNASSIGNED STEPS</strong>. This will delete all the steps that were copied and were not assigned to any topics? This action cannot be undone.',
                type:'is-danger',
                onConfirm:()=>{
                    Vue.$stepService.deleteUnassigned().then(()=>{
                        this.$buefy.toast.open({
                            message:'Unassigned steps deleted!',
                            type:'is-success',
                            queue: false
                        })
                        this.reloadSteps();
                    })
                }
            })
        },
        async sort(event,type){
            if(event.added && type === 'topic'){
                if ( ! this.filter.topicId) {
                    this.$buefy.toast.open({
                        message: "A topic must be selected.",
                        type:'is-info',
                    });
                    return;
                }
                this.$buefy.toast.open({
                    message:'Step is cloning, please wait.',
                    type:'is-success',
                    queue: false
                })
                await this.processStepClone(event)
            }
            if(type==='topic' && event.moved){
                let steps = this.topic_steps;
                let ids = _.map(steps,'id');
                await Vue.$stepService.sort({ids:ids}).then(()=>{
                    this.$buefy.toast.open({
                        message:'Steps are sorted!',
                        type:'is-success'
                    })
                });
            }else if(type === 'test' && event.moved){
                this.$buefy.toast.open({
                    message:'You cannot sort this list!',
                    type:'is-danger',
                    queue: false
                })
            }
            return true;
        },
        async processStepClone(event){
            let step = await this.clone(event.added.element);
            step = step.data
            // let index = _.findIndex(this.topic_steps,{id:event.added.element.id})
            // let steps = this.topic_steps;
            // steps.splice(index,1,step);
            // this.topic_steps = steps
            this.topic_steps.splice(event.added.newIndex, 1, step); // Remove the step that vuedraggable added and replace it with the cloned step
            let ids = _.map(this.topic_steps,'id');
            return Vue.$stepService.sort({ids:ids}).then(()=>{
                this.$buefy.toast.open({
                    message:'Steps are sorted!',
                    type:'is-success',
                    queue: false
                })
            });
        },
        async updateTopicId(){
            await this.reloadSteps();
            this.$emit('topic',this.filter.topicId);
        },
        isShow(step){
            let isShow = true;
            if (step.attributes.topic_id) {
                isShow = ((step.attributes.topic_id == this.filter.topicId) || ! this.filter.topicId);
            }
            else if (step.attributes.test_result_id) {
                isShow = ((step.attributes.test_result_id == this.filter.testResultId) || ! this.filter.testResultId);
            }
            return isShow;
        },
        async reloadData(){
            // this.isLoaded = false
            if(this.isFirstLoad){
                if (this.$store.state.guideTopicId) {
                    this.filter.topicId = this.$store.state.guideTopicId;
                }
                if (this.$store.state.guideTestResultId) {
                    this.filter.testResultId = this.$store.state.guideTestResultId;
                }
                this.filter.topicId = this.topicId || this.filter.topicId;
                this.isFirstLoad = false
            }else{
                this.filter.topicId = null
            }
            this.$store.commit('SET_SELECTED_APP_GUIDE',this.appSelected)
            await this.getTopics()
            await this.getTestResults();
            this.reloadSteps()
            // this.isLoaded = true
        },
        async clone(row){
            return Vue.$stepService.clone({
                id: row.id,
                topic_id: this.filter.topicId || undefined,
            });
        },
        async reloadSteps(){
            this.steps = [];
            await this.$store.commit('SET_IMAGES',[]);
            this.page=1
            this.isLoaded = false;
            if (this.filter.topicId || this.filter.testResultId) {
            await this.getSteps()
            }
            this.isLoaded = true;
            let show = this.show
            // this.topic_steps = _.filter(this.steps,(step)=>{
            //     return step.attributes.test_result_id===null && (!show ? step.attributes.status : true)
            // })
        },
        deleteStep(props, confirmation = true){
            if(confirmation){
                this.$buefy.dialog.confirm({
                    title:'Are you sure?',
                    message:'Are you sure you want to this step? This action cannot be undone.',
                    type:'is-danger',
                    onConfirm:()=>{
                        this.$buefy.toast.open({
                            type:'is-success',
                            message:'Deleting step...',
                            queue: false
                        })
                        return Vue.$stepService.delete(props.id).then(async ()=>{
                            await this.reloadSteps()
                            this.$store.commit('SET_IMAGES',{
                                steps:this.steps
                            })
                            this.$buefy.toast.open({
                                type:'is-success',
                                message:'Step deleted!',
                                queue: false
                            })
                        })
                    }
                });
            }else{
                return Vue.$stepService.delete(props.id).then(async ()=>{
                    this.$store.commit('SET_IMAGES',{
                        steps:this.steps
                    })
                })
            }
        },
        getTopicName(id){
            if(this.topics.length){
                let topics = this.topics.filter(element=>{
                    return parseInt(element.id)===parseInt(id)
                })
                if(topics.length){
                    return topics[0].attributes.title
                }
            }
            return null
        },
        async startUpdating(){
            this.countMode = 'Updating'
            this.updateIndex = 1
            this.isUpdating = true;
            this.isLoaded = false
            for(const element in this.stepsToUpdate){
                let step = this.stepsToUpdate[element];
                step.attributes.topic_id = this.topicSelected
                await this.save(step);
                this.updateIndex++
            }
            this.isUpdating = false
            this.isLoaded = true;
            this.stepsToUpdate = []
            this.$buefy.toast.open({
                type:'is-success',
                message:'Steps are updated!',
                queue: false
            })
            await this.reloadSteps()
        },
        modeChange(){
            this.sorting = !this.sorting
        },
        async multipleRestoreOrArchive(restoreOrArchive = true){
            this.countMode = 'Updating'
            this.updateIndex = 1
            this.isUpdating = true;
            this.isLoaded = false
            for(const element in this.stepsToUpdate){
                let step = this.stepsToUpdate[element];
                // save() already toggles status
                // step.attributes.status = !step.attributes.status
                // Force set status to 1/0
                await this.save(step, restoreOrArchive);
                this.updateIndex++
            }
            this.isUpdating = false
            this.isLoaded = true;
            this.stepsToUpdate = []
            this.$buefy.toast.open({
                type:'is-success',
                message: `Selected steps are ${restoreOrArchive ? "restored" : "archived"}!`,
                queue: false
            })
            await this.reloadSteps()
        },
        async multipleDelete(){
            this.$buefy.dialog.confirm({
                title:'Are you sure?',
                message:'Are you sure you want to these steps? This action cannot be undone.',
                type:'is-danger',
                onConfirm:async ()=>{
                    this.countMode = 'Deleting'
                    this.updateIndex = 1
                    this.isUpdating = true;
                    this.isLoaded = false
                    this.$buefy.toast.open({
                        type:'is-success',
                        message:'Deleting selected steps...',
                    })
                    await this.processDeletion().then(()=>{
                        this.reloadSteps()
                    })
                    this.isUpdating = false
                    this.isLoaded = true;
                    this.stepsToUpdate = []
                    this.$buefy.toast.open({
                        type:'is-success',
                        message:'Selected steps are deleted!',
                    })
                }
            });
        },
        async processDeletion(){
            // return Promise(async(resolve)=>{
                for await(const step of this.stepsToUpdate){
                    step.attributes.status = !step.attributes.status
                    await this.deleteStep(step,false);
                    this.updateIndex++
                }
                // resolve('ok');
            // })
        }

    }
}
</script>

<style scoped>
    .line-height-2{
        line-height: 2;
    }
</style>
